import { type Enum } from '@webapp/infrastructure/types/Enum'

export const LlmConfirmationModes = {
  REPLACES_RESULTS: 'replaces-results',
  WITH_RESULTS: 'with-results',
} as const

export type LlmConfirmationModeEnum = Enum<typeof LlmConfirmationModes>
